
import React,{Component } from "react";

import {
    Grid,
} from "tabler-react";

import './CurriculumVitae.css';

interface HelloMessageProps {
}
class Spacer extends Component {
    componentDidMount() {
      window.scrollTo(0, 0);
    }
  
    render() {
      return <span className='d-sm-none' style={{width:10,display: 'inline-block'}}/>;
    }
  }
export default class CurriculumVitae extends Component<HelloMessageProps, {}>{
    getCV() {
        return [
            { title: 'Profil:', value: 'Freiberufler (Senior Software Entwickler)\n' },
            { title: 'Name:', value: 'Dipl. Inform. Mahmut Keygubatli\n' },
            { title: 'Wohnort:', value: 'Dortmund' },
            { title: 'E-Mail:', value: 'mahmut.keygubatli@areaway.de\n' },
            { title: 'Mobil:', value: '+49 171 833 1495\n' },
            { title: 'Nationalität:', value: 'Türkisch' },
            { title: '', value: '1968\n' },
            { title: 'Ausbildung:', value: 'Diplom Informatiker 1997\nNebenfach: Medizin\nan der Technischen Universität Dortmund\n\nAbitur 1989\nam Reinoldus-Schiller Gymnasium\n' },
            { title: 'Schwerpunkt:', value: 'Browser-basierte UI/UX Entwicklung\nHTML5 & CSS3, Javascript, Typescript, ES6,\nJQuery, JQuery UI, React.js, Vue.js\nWeb & Applikation (Client / Server)\nBenutzeroberflächen, Relationale Datenbanken\n' },
            { title: 'Sprachen:', value: 'Deutsch: Muttersprache\nEnglisch: Gut\nTürkisch: Muttersprache\n' },
            { title: 'Branchenerfahrung:', value: 'OnlineShop\n(Konfigurator, Auftragsabwicklung, Produktion)\nTelekommunikation\n(Funknetzdarstellung)\nBaubranche\n(CAD System für Großbauprojekte)\nGroßhandel\n(Standortplanung)\nEnergieversorger\n(Leitungsplanung, Störfallplanung)\n' },
            { title: 'Programmiersprachen:', value: 'JavaScript (10 Jahre +++)\nTypeScript (1 Jahr ++)\nES6 (2 Jahr +++)\nPHP (7 Jahre ++)\nRuby (0,25 Jahr ++)\nJava (12 Jahre +++)\nC# (6 Jahre ++)\nVisualBasic (6 Jahre ++) \nC/C++ (4 Jahre ++) \nObjective C (4 Jahre ++) \nActionScript 3 (2 Jahre ++) \nABAP (0,5 Jahr +)\nPerl (0,5 Jahr +)\n' },
            { title: 'Zertifizierungen:', value: 'MCP (Microsoft Certified Profesional)\nSCJP (Sun Certified Java Programmer)\n' },
            { title: 'Schulungen:', value: 'Oracle 8i Spatial\nESRI ArcObj .Net C#\nEnglisch für Fortgeschrittene\n'
            +'Shopware Template Training Basic\nShopware Template Training Advanced\nShopware Developer Training Basic\nShopware Developer Training Advanced\n' },
            { title: 'IDE:', value: 'Visual Sudio Code (2 Jahre +++)\nPHP Storm (3 Jahre +++)\nEclipse (9 Jahre +++)\nXcode (4 Jahre +++)\nVisual Studio (9 Jahre +++) \nNotepad++ (7 Jahre +++)\nArduino (4 Jahre +++)\nvi (7 Jahre +++)\nSAP Gui (0,5 Jahr +)\n' },
            { title: 'Tools:', value: 'Node.js/ Npm (3 Jahre +++)\nJenkins (1 Jahr +++)\nGitea (1 Jahr +++)\nAnt (5 Jahre +++)\nMaven (1 Jahr +)\nJMeter (2 Jahre ++)\ncsh/ksh (2 Jahre ++)\nBugzilla / Mantis (9 Jahre +++)\nGit (2 Jahre ++)\nSVN (9 Jahre +++)\nVisual Source Save (9 Jahre +++)\n' },
            {
                title: 'Frameworks / Bibliotheken:', value: 'React.js (2 Jahre +++)\nVue.js (0,5 Jahr ++)\nJest (1 Jahr +++)\nPuppeteer (1 Jahr +++)\njQuery (6 Jahre +++)\njQuery UI (4 Jahre +++)\nMootools (2 Jahre +++)\nStruts / Tiles (4 Jahre ++)\nJUnit (5 Jahre +++)\nJSP (5 Jahre +++)\nServlet (6 Jahre +++)\nRest (4 Jahre +++)\n'
                +'Soap/ WebServices (6 Jahre +++)\nJDO (1 Jahr ++)\nRedBeanPHP (2 Jahre +++)\n'
                    + 'JasperReports (3 Jahre +++)\nJFreeChart (3 Jahre +++)\nSmarty (2 Jahre +++)\nCakePHP (6 Jahre ++)\nfPDF (3 Jahre +++)\nShopware (1 Jahr +++)\nOS Commerce (2 Jahre +++)\n.Net (6 Jahre +++)\nMicrosoft Foundation Classes (MFC) (2 Jahre +++)\nSocket TCP/IP (1 Jahr +++)\nCocos2D (1 Jahr +++)\n'
                    + 'Box2D (1 Jahr ++)\nOpen GL (1 Jahr ++)\nSAP Web DynPro (Java) (0,5 Jahr +)\nRED5 (1 Jahr +)\nFFMPEG (1 Jahr +)\n'
            },
            { title: 'Server / Datenbanken:', value: 'Apache HTTP Server (11 Jahre +++)\nTomCat (6 Jahre +++)\nJBoss (1 Jahr ++)\nOracle 8i/9i (10 Jahre ++)\nMySQL(10 Jahre +++)\nMicrosoft SQL Server(5.5 Jahre +++)\nDB2 (0,5 Jahr +)\nSQLite (5 Jahre +++)\nFoxPro /dBase(3 Jahre +++)\nClipper (1 Jahr ++)\n' },
            { title: 'UML / Entwurfsmuster:', value: 'Clean Code (1 Jahr ++)\nRational Rose (1 Jahr +)\nEntwurfsmuster / GoF (15 Jahre +++)\n' },



        ];
    }
    render() {
        let elements = this.getCV().map((item, index) =>
            <React.Fragment key={index}>
                <Grid.Col width={12} sm={5} md={4} lg={3} xl={2}>{item.title}</Grid.Col>
                <Grid.Col width={12} sm={7} md={8} lg={9} xl={10}>{
                    item.value.split('\n').map((item, key) => {
                        return <React.Fragment key={key}><Spacer/>{item}<br /></React.Fragment>
                    })
                }</Grid.Col>
            </React.Fragment>
        );

        return (
            <Grid.Row className="curriculum-vitae">
                {elements}
            </Grid.Row>
        );
    }
}